import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Search, Wind, Leaf, Sparkles, Zap, Heart } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ArtaBenefits() {
  const benefits = [{
    icon: Brain,
    title: 'Înțelegi ce este stresul și cum funcționează',
    desc: 'Nu te mai simți victima stresului. Înțelegi mecanismul, îl recunoști când apare și știi exact ce să faci.'
  }, {
    icon: Search,
    title: 'Identifici tipurile de stres din viața ta',
    desc: 'Nu mai e un nor difuz de "sunt stresat/ă." Știi exact ce te stresează, de ce te stresează și cum să gestionezi fiecare situație.'
  }, {
    icon: Wind,
    title: 'Îți calmezi mintea în câteva minute',
    desc: 'Tehnicile de respirație și relaxare din curs funcționează rapid. Le folosești oricând și oriunde, chiar și într-un program aglomerat.'
  }, {
    icon: Leaf,
    title: 'Creezi obiceiuri care îți susțin liniștea zilnic',
    desc: 'Nu doar soluții de moment, ci un mod de viață. Obiceiuri simple pe care le integrezi natural și care te țin în echilibru pe termen lung.'
  }, {
    icon: Sparkles,
    title: 'Te eliberezi de stresul acumulat',
    desc: 'Stresul pe care l-ai adunat în luni sau ani nu dispare singur. Aici înveți cum să îl eliberezi conștient și să te simți ușor/ușoară.'
  }, {
    icon: Zap,
    title: 'Ai mai multă energie și claritate',
    desc: 'Când stresul scade, energia crește. Gândurile devin clare. Deciziile vin mai ușor. Și ai din nou puterea de a face lucrurile care contează.'
  }, {
    icon: Heart,
    title: 'Te bucuri de viață, nu doar supraviețuiești',
    desc: 'Asta e schimbarea cea mai mare. Nu mai alergi. Trăiești. Cu prezență, cu bucurie și cu timp pentru tine.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6" data-id="element-104">
        <SectionHeading title="Ce se schimbă concret după acest curs" data-id="element-105" />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-106">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-107">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-108">
                  <Icon className="w-8 h-8" data-id="element-109" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-110">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-111">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-112">
          <CTAButton data-id="element-113" />
        </motion.div>
      </div>
    </section>;
}